module.exports = __webpack_public_path__ + "static/media/register_icn.3eb1bd9a.svg";